import type { DataOption } from '@/entities/column'
import type { AnchorsAlertsItemModel } from '@/shared/generated'

import { map, paths, pipe } from 'lodash/fp'
import { useTranslation } from 'react-i18next'

import {
	getAnchorsTypesChoices,
	useAnchorsAlertsAnnotationsQuery,
} from '@/entities/anchor'
import {
	getSalesEntitiesTree,
	useOptimizationGroupsQuery,
	useSalesEntitiesQuery,
} from '@/entities/optimization-group'

import { toOption } from '@/shared/tools/utils'

export function useColumnChoices() {
	const { t } = useTranslation()

	const salesEntitiesQuery = useSalesEntitiesQuery()
	const { data: alerts } = useAnchorsAlertsAnnotationsQuery({
		select: (data: AnchorsAlertsItemModel[]) =>
			data.map(({ name, id }) => ({
				value: id,
				label: t(name, { defaultValue: id }),
			})),
	})
	const optimizationGroupsQuery = useOptimizationGroupsQuery<DataOption[]>({
		select: pipe(map(paths(['id', 'name'])), toOption),
	})

	return {
		anchor_type: getAnchorsTypesChoices(t),
		pos_ids: getSalesEntitiesTree(salesEntitiesQuery.data) || [],
		sales_entity_id: getSalesEntitiesTree(salesEntitiesQuery.data) || [],
		alerts: alerts || [],
		optimization_group_id: optimizationGroupsQuery.data || [],
	}
}
